import React, { useState } from 'react';
import './ToolsSection.css';
import tool1 from '../assets/1.png';
import tool2 from '../assets/3.png';
import tool3 from '../assets/4.png';
import backgroundImg from '../assets/8.png'; 

const tools = [
  {
    id: 1,
    title: 'Google Local Search Results Checker',
    description:
      'Discover the power of viewing localized Google search results from any location. Analyze local rankings, track competitors, and gain precise insights tailored to specific regions. Perfect for businesses and marketers looking to optimize their strategies and grow locally.',
    image: tool1,
    link: 'https://outreachdigitalmarketing.com/local-search-results-checker/',
  },
  {
    id: 2,
    title: 'Meta Mine',
    description:
      'Meta Mine is a powerful Chrome extension that effortlessly fetches and analyzes meta tags, internal/external links, readability scores, and more. Ideal for developers, SEO experts, and marketers, it helps optimize web pages for better performance and enhanced digital strategies.',
    image: tool2,
    link: 'https://chromewebstore.google.com/detail/meta-mine/eccfnnkfgchogdkplpbjjcnajcdgkfbi',
  },
  {
    id: 3,
    title: 'Google Review Link Generator',
    description:
      'Effortlessly generate a Google review link for your business with just one click. Share it with customers to gather valuable feedback and boost your online reputation. Simplify the review process and enhance customer engagement with this easy-to-use tool.',
    image: tool3,
    link: 'https://tools.outreachdigitalmarketing.com/review-generator/',
  },
];

const ToolsSection = () => {
    const [focusedTool, setFocusedTool] = useState(2); 
  
    const handleMouseEnter = (id) => {
      setFocusedTool(id);
    };

    const handleMouseLeave = () => {
        setFocusedTool(2); 
      };

  return (
    <div className="tools-section"
    style={{
        backgroundImage: `url(${backgroundImg})`, 
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>
      {tools.map((tool) => (
        <div
          key={tool.id}
          className={`tool-panel ${
            focusedTool === tool.id ? 'focused' : 'blurred'
          }`}
          onMouseEnter={() => handleMouseEnter(tool.id)}
          onMouseLeave={handleMouseLeave}
        >

          <div className="tool-panel-inner">
            <div className="tool-panel-front">
              <img src={tool.image} alt={tool.title} className="tool-image" />
              <div className="horizontal-line"></div>
              <h3 className="tool-title">{tool.title}</h3>
              <div className="horizontal-line"></div>
            </div>
            <div className="tool-panel-back">
            <h3 className="tool-title-back">{tool.title}</h3>
              <p className="tool-description">{tool.description}</p>
              <a
                href={tool.link}
                target="_blank"
                rel="noopener noreferrer"
                className="tool-link"
              >
                Explore Tool
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ToolsSection;